module.exports = __webpack_public_path__ + "img/pos_s2_icon2.7ac91913.png";